import { render, staticRenderFns } from "./adddriver.vue?vue&type=template&id=62988136&scoped=true"
import script from "./adddriver.js?vue&type=script&lang=js&external"
export * from "./adddriver.js?vue&type=script&lang=js&external"
import style0 from "./adddriver.vue?vue&type=style&index=0&id=62988136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62988136",
  null
  
)

export default component.exports